import React from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';
import { HelpCircle } from 'lucide-react';

/**
 * Mobile-optimized tooltip component
 * Features:
 * - Touch-friendly targets (44px minimum)
 * - Short, legible text
 * - Auto-positioning
 * - Works on desktop (hover) and mobile (tap)
 */
export const TooltipWrapper = ({ 
  children, 
  content, 
  side = 'top',
  className = '',
  iconSize = 16
}) => {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger 
          asChild={!!children}
          className={`inline-flex items-center justify-center ${!children ? 'min-w-[44px] min-h-[44px]' : ''} ${className}`}
          data-testid="tooltip-trigger"
        >
          {children || (
            <HelpCircle 
              className="text-muted-foreground hover:text-foreground transition-colors cursor-help" 
              size={iconSize}
              strokeWidth={1.5}
            />
          )}
        </TooltipTrigger>
        <TooltipContent 
          side={side}
          className="max-w-xs sm:max-w-sm z-50 bg-popover text-popover-foreground shadow-md"
          sideOffset={5}
          data-testid="tooltip-content"
        >
          <p className="text-sm leading-relaxed">{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

// Predefined tooltip contents for common use cases
export const TOOLTIP_CONTENT = {
  overallScore: "Your combined readiness and opportunity score (0–100). Higher = greater ROI potential.",
  impactEffortMatrix: "Rate each opportunity's impact and effort to implement.",
  hourlyValue: "Typical hourly cost for a person doing this work.",
  roiFormula: "Annual Cost = Hours/Week × Hourly Value × 52.",
  integrationRating: "How well your current tools work together (1=poorly, 5=seamlessly).",
  quickWins: "High-impact opportunities that require low effort to implement.",
  category: "Select the business area where this process belongs.",
  process: "What specific task or workflow could be automated or improved?",
  difficulty: "Automation difficulty: 1=Very Easy • 2=Easy • 3=Moderate • 4=Difficult • 5=Very Difficult",
  impact: "Potential business impact: 1=Low impact • 5=High impact. Consider time saved, revenue gained, or customer satisfaction improved."
};